/**
 * @class ProductRecommendations
 * @extends HTMLElement
 * @description A class that fetches and renders product recommendations.
 * @docs https://shopify.dev/docs/themes/architecture/sections/product-recommendations
 * @example
 * <product-recommendations data-url="https://example.com/api/products"></product-recommendations>
 */
class ProductRecommendations extends HTMLElement {
  /**
   * @method connectedCallback
   */
  connectedCallback() {
    if (!this.dataset.url) return;
    this.fetchRecommendations();
  }

  /**
   * @method removeLoaders
   * @description Removes the loaders from the product recommendations if the recommendations are loaded. If not the fallback products will be shown.
   */
  removeLoaders() {
    // A small timeout is used to ensure the innerHTML operation has completed to ensure the animation works.
    setTimeout(() => {
      this.querySelectorAll('[data-loader]').forEach((loader) => {
        loader.ariaHidden = true;
      });
    }, 50);
  }

  /**
   * @method fetchRecommendations
   * @description Fetches the product recommendations from the Shopify API.
   */
  fetchRecommendations() {
    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('[data-product-recommendations]')?.innerHTML;

        if (html) {
          this.innerHTML = html;
        }
        this.removeLoaders();
      })
      .catch((error) => {
        console.error('Failed to fetch product recommendations:', error);
        this.removeLoaders();
      });
  }
}

customElements.define('product-recommendations', ProductRecommendations);
